/* Inline by default: an id belongs inside a sentence and inside a table cell, not on a
   line of its own. Truncating needs a block box and a single line — an inline box ignores
   overflow, and the ellipsis has nothing to clip without `nowrap`. */

.mono {
  font-family: var(--font-mono);
  font-size: var(--step-n1);
  font-variant-numeric: tabular-nums;
}

.truncate {
  display: block;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
